/* eslint-disable react/jsx-key */
import React, { FC } from 'react';
import { useTable, Column } from 'react-table';
import cc from 'classnames';
import { useMediaQuery, useTheme } from '@material-ui/core';
import noop from 'utils/noop';
import styles from './Table.module.css';

interface ITable {
  columns: Array<Column>;
  data: Array<any>;
  emptyTableMessage?: string;
  icons?: Record<string, React.ReactNode>;
  isStandingOrder?: boolean;
  onClick?: (row) => void;
  getCellValue?: (cell) => void
  tableButton?: Record<string, React.ReactNode>;
}

const Table: FC<ITable> = ({
  columns,
  data,
  emptyTableMessage = '',
  icons,
  tableButton,
  isStandingOrder = false,
  onClick = noop,
  getCellValue = noop,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

  const downLgScreen = useMediaQuery(useTheme().breakpoints.down('lg'));

  // const getColor = (cell) => {
  //   if (cell.column.Header !== 'Amount' || isStandingOrder) {
  //     return 'unset';
  //   }
  //   return cell.value.indexOf('-') > 0 ? '#EE312A' : '#27AE60';
  // };

  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
            {
              tableButton
              && (
              <th>{}</th>
              )
            }
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.length > 0 ? (
          rows.map((row: any) => {
            prepareRow(row);
            return (
              <tr
                onClick={() => onClick && onClick(row)}
                {...row.getRowProps()}
                className={cc(
                  isStandingOrder ? styles.cursorPointer : undefined,
                  (row.original.code && row.original.code === 10) ? styles.beneficiaryStatus : undefined,
                )}
              >
                {row.cells.map((cell) => (
                  <td
                    onClick={() => getCellValue && getCellValue(cell)}
                    {...cell.getCellProps()}
                    aria-hidden="true"
                  >
                    <div
                      className={cc(
                        styles.flexContainer,
                        cell.value === 'Active' ? styles.active : '',
                        cell.value === 'Cancelled' ? styles.cancelled : '',
                        cell.value === 'Pending' ? styles.pending : '',
                      )}
                      style={{
                        maxWidth: downLgScreen ? '280px' : cell.column.width,
                        display: cell.column.Header === 'Type' ? 'flex' : 'block',
                        // color: getColor(cell),
                      }}
                    >
                      {icons && icons[cell.value]}
                      {cell.render('Cell')}
                    </div>
                  </td>
                ))}
                {
                  tableButton
                  && (
                  <td role="cell">
                    <div
                      style={{
                        maxWidth: '240px',
                        display: 'block',
                      }}
                    >
                      {tableButton && tableButton.button}
                    </div>
                  </td>
                  )
                }
              </tr>
            );
          })
        ) : (
          <tr className={styles.emptyMessage}>
            <td>{emptyTableMessage}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default Table;
